import type { NextPage } from 'next';
import DiscoveryComponent from '@components/expertise/discovery/discovery';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import { useRouter } from 'next/router';
import { config } from 'config';
import { generateProductJsonLd } from '@helpers/genereteProductsJsonLd';

const Discovery: NextPage = () => {
  const router = useRouter();
  const url = `${config.HOST}${router.asPath}`;
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Discovery Phase Services 💡 | Agilie',
          description:
            "Not sure where to start? We'll map out your project: scope, tech stack, timeline, costs. Book a discovery call!",
          imageUrl: '/discovery-images/discovery-phase-image-meta.png',
        })}
        <link rel="icon" href="/favicon.ico" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateProductJsonLd({
                serviceType: 'Discovery Phase Services | Agilie',
                description:
                  "Not sure where to start? We'll map out your project: scope, tech stack, timeline, costs. Book a discovery call!",
                url,
              }),
            ),
          }}
        />
      </Head>
      <MainLayout>
        <DiscoveryComponent />
      </MainLayout>
    </>
  );
};

export default Discovery;
